export const getFilesFromUploadEvent = (event: HTMLFileUploadEvent): Array<File> => {
  const files = event.target.files || event.dataTransfer.files;
  return [...files];
};
